import React, { useRef, useEffect } from 'react';
import * as echarts from 'echarts/core';
import { BarChart, LineChart } from 'echarts/charts';
import {
	TitleComponent,
	TooltipComponent,
	GridComponent,
	LegendComponent,
	DataZoomComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
	TitleComponent,
	TooltipComponent,
	GridComponent,
	LegendComponent,
	DataZoomComponent,
	BarChart,
	LineChart,
	CanvasRenderer,
]);

const EChartsBarChart = ({ options, style, minHeight, maxHeight }) => {
	const chartRef = useRef(null);

	useEffect(() => {
		let chartInstance = null;
		if (chartRef.current) {
			chartInstance = echarts.init(chartRef.current);
			chartInstance.setOption(options);

			// Resize inmediatamente después de inicializar
			setTimeout(() => {
				chartInstance?.resize();
			}, 0);
		}

		const resizeChart = () => {
			chartInstance?.resize();
		};

		window.addEventListener('resize', resizeChart);

		return () => {
			chartInstance?.dispose();
			window.removeEventListener('resize', resizeChart);
		};
	}, [options]);

	// Efecto adicional para manejar cambios en el contenedor
	useEffect(() => {
		if (chartRef.current) {
			const el = chartRef.current;
			if (!el) return;
			
			const chartInstance = echarts.init(el);

			const resizeObserver = new ResizeObserver(() => {
				if (!chartRef.current) return;
				const chart = echarts.getInstanceByDom(el);
				if (chart) chart.resize();
			});

			resizeObserver.observe(el);

			return () => {
				resizeObserver.disconnect();
				chartInstance.dispose();
			};
		}
	}, []);

	return (
		<div
			ref={chartRef}
			style={{
				width: '100%',
				height: maxHeight || minHeight || '300px',
				minHeight: minHeight || '200px',
				...style,
			}}
		/>
	);
};

export default EChartsBarChart;
